import { useState, useEffect } from "react";
import { useUserStore } from "../store/userStore";
import MainLayout from "../layouts/MainLayout";
import PresidenteDashboard from "../components/presidente/Dashboard";
import PresidenteNuevaSolicitud from "../components/presidente/NuevaSolicitud";
import AlcaldeDashboard from "../components/alcalde/Dashboard";
import AlcaldeSolicitudes from "../components/alcalde/Solicitudes";
import MapaTerritorial from "../components/alcalde/MapaTerritorial";

export default function DespachoPage() {
  const { role, user, setUser } = useUserStore();
  const [currentTab, setCurrentTab] = useState("dashboard");

  useEffect(() => {
    // Inicializar con datos por defecto
    if (!user.name || user.name === "Usuario") {
      setUser({
        id: 1,
        name: "Juan García",
        barrio: "Centro",
        email: "juan@example.com"
      });
    }
  }, []);

  const renderContent = () => {
    if (role === "presidente") {
      return (
        <>
          {currentTab === "dashboard" && <PresidenteDashboard presidentialId={user.id} currentTab={currentTab} onTabChange={setCurrentTab} />}
          {currentTab === "nueva-solicitud" && <PresidenteNuevaSolicitud presidentialId={user.id} />}
          {currentTab === "mis-solicitudes" && <PresidenteDashboard presidentialId={user.id}  currentTab={currentTab} onTabChange={setCurrentTab}/>}
          {currentTab === "mapa" && <MapaTerritorial />}
        </>
      );
    } else {
      return (
        <>
          {currentTab === "dashboard" && <AlcaldeDashboard />}
          {currentTab === "solicitudes" && <AlcaldeSolicitudes />}
          {currentTab === "mapa-territorial" && <MapaTerritorial />}
          {currentTab === "areas" && <AlcaldeDashboard />}
          {currentTab === "reportes" && <AlcaldeDashboard />}
        </>
      );
    }
  };

  return (
    <MainLayout currentTab={currentTab} onTabChange={setCurrentTab}>
      {renderContent()}
    </MainLayout>
  );
}
